"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const typography_css_1 = __importDefault(require("../../../styles/global_ui/typography.css"));
const membership_css_1 = __importDefault(require("./membership.css"));
const MembershipPage = () => (react_1.default.createElement("main", { className: membership_css_1.default.background },
    react_1.default.createElement("h1", { className: typography_css_1.default.h1Responsive }, "Coming Soon!")));
exports.default = MembershipPage;
